import Service, { LegacyService } from "../Service";
import PersistentData from "../PersistentData";


export default class AccountService{
    persistent = new PersistentData('Account');
    clinicData = new PersistentData('ClinicData/Clinic');


    get token(){
        return this.persistent.getData('token');
    }

    get userId(){
        return this.persistent.getData('userId');
    }

    get clinicId(){
        return this.persistent.getData('clinicId');
    }
    set clinicId(id){
        this.persistent.setData('clinicId', id)
    }

    get clinics(){
        return this.persistent.getData('clinics');
    }

    get clinicName(){
        return this.clinicData.getData(this.clinicId).name; //this.persistent.getData('clinicName');
    }

    get fullName(){
        return this.persistent.getData('fullName');
    }

    get lastName(){
        return this.persistent.getData('lastName');
    }

    get firstName(){
        return this.persistent.getData('firstName');
    }

    get isLoggedIn(){
        return this.token != null;
    }

    logout(){
        let loggedOutAccount = this.persistent.getAll();
        this.persistent.clear();
        window.dispatchEvent(new CustomEvent('LoggedOut', {details:loggedOutAccount} ));
    }

    login(clinicId, pin, cb){
        let service = new Service();
        service.request("Account" , {
            get: {
                    clinicId: clinicId,
                    pin: pin,
                    appCode: "am",
                    appVersion: "1.1"
                },
            post: true
        }).then(
            (json) => {
                this.persistent.clear();
                if(json.token){
                    this.persistent.clear();
                    console.log('Logged In:', json)
                    if(json.clinics) {
                        try{
                            json.clinics.sort((a, b) => {
                                //console.log('an:', a, '  bn:', b)
                                const an = (a.name || '').toUpperCase();
                                const bn = (b.name || '').toUpperCase();
                                if(an < bn) return -1;
                                if(an > bn) return 1;
                                return 0;
                            })
                        } catch(e) {
                            console.log('Clinic Sort Fail:', e);
                        }

                    }
                    for(var p in json){
                        this.persistent.setData(p, json[p]);
                    }
                    /*Cookies.set('SessionID', json.token, { path: '/' });
                    Cookies.set('biopedam-defaultclinic', clinicId, { path: '/' });
                    LegacyService.Login(clinicId, pin).then((r) => {
                        console.log('Legacy Login:', r);
                        LegacyService.DownloadDoc('treatment', 21227, {})
                    })*/

                }
                if(cb){
                    cb(this);
                }
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/api/services/AccountService.js